import gql from 'graphql-tag';

const S12nRecsFragment = gql`
  fragment S12nRecsFragment on ProgramCurriculumCollectionsV1 {
    id
    title
    image
    s12nIds
    collectionTrackingId
    description {
      ... on ProgramCurriculumCollectionsV1_cmlMember {
        cml {
          dtdId
          value
        }
      }
    }
    trackId
    s12ns(limit: $numEntriesPerCollection) {
      elements {
        id
        name
        slug
        logo
        courseIds
        partners {
          elements {
            id
            name
            squareLogo
          }
        }
        productVariant
      }
    }
    associatedSessions {
      elements {
        id
        courseId
        startsAt
        endsAt
      }
    }
  }
`;

export const EnterpriseS12nRecommendationsForSkillIdQuery = gql`
  query EnterpriseS12nRecommendationsForSkillId(
    $programId: String!
    $numEntriesPerCollection: Int!
    $hasSkillId1: Boolean = false
    $skillId1: String = ""
    $hasSkillId2: Boolean = false
    $skillId2: String = ""
    $hasSkillId3: Boolean = false
    $skillId3: String = ""
    $hasSkillId4: Boolean = false
    $skillId4: String = ""
    $hasSkillId5: Boolean = false
    $skillId5: String = ""
    $hasSkillId6: Boolean = false
    $skillId6: String = ""
  ) {
    ProgramCurriculumCollectionsV1Resource {
      s12nRecs1: skillCollectionBySkillId(
        programId: $programId
        skillId: $skillId1
        numEntriesPerCollection: $numEntriesPerCollection
      ) @include(if: $hasSkillId1) {
        elements {
          ...S12nRecsFragment
        }
      }
      s12nRecs2: skillCollectionBySkillId(
        programId: $programId
        skillId: $skillId2
        numEntriesPerCollection: $numEntriesPerCollection
      ) @include(if: $hasSkillId2) {
        elements {
          ...S12nRecsFragment
        }
      }
      s12nRecs3: skillCollectionBySkillId(
        programId: $programId
        skillId: $skillId3
        numEntriesPerCollection: $numEntriesPerCollection
      ) @include(if: $hasSkillId3) {
        elements {
          ...S12nRecsFragment
        }
      }
      s12nRecs4: skillCollectionBySkillId(
        programId: $programId
        skillId: $skillId4
        numEntriesPerCollection: $numEntriesPerCollection
      ) @include(if: $hasSkillId4) {
        elements {
          ...S12nRecsFragment
        }
      }
      s12nRecs5: skillCollectionBySkillId(
        programId: $programId
        skillId: $skillId5
        numEntriesPerCollection: $numEntriesPerCollection
      ) @include(if: $hasSkillId5) {
        elements {
          ...S12nRecsFragment
        }
      }
      s12nRecs6: skillCollectionBySkillId(
        programId: $programId
        skillId: $skillId6
        numEntriesPerCollection: $numEntriesPerCollection
      ) @include(if: $hasSkillId6) {
        elements {
          ...S12nRecsFragment
        }
      }
    }
  }
  ${S12nRecsFragment}
`;
